module.exports = __webpack_public_path__ + "static/logo-moo-354db394eb509a8c4e702eae1b13c35d.png";